import React, { useState, useEffect } from "react"

export const CountrySelector = ({
  onCountryChange,
  selectedCountry,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isDetecting, setIsDetecting] = useState(false)

  const countries = [
    {
      code: "IN",
      flag: "https://api.builder.io/api/v1/image/assets/TEMP/23f0595131de1cb2ef9b3f216b19b44940585902?placeholderIfAbsent=true",
      name: "India",
      countryCode: "IN",
    },
  ]

  useEffect(() => {
    const detectCountry = async () => {
      if (selectedCountry) return

      setIsDetecting(true)
      try {
        const response = await fetch("https://ipapi.co/json/")
        const data = await response.json()

        const detectedCountry = countries.find(
          c => c.countryCode === data.country_code
        )
        if (detectedCountry && onCountryChange) {
          onCountryChange(detectedCountry.code)
        }
      } catch (error) {
        console.error("Failed to detect country:", error)

        if (onCountryChange) {
          onCountryChange("IN")
        }
      } finally {
        setIsDetecting(false)
      }
    }

    detectCountry()
  }, [])

  const selectedCountryData =
    countries.find(c => c.code === selectedCountry) || countries[0]

  return (
    <div className="country-selector">
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className="country-button"
        aria-label="Select country"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <img
          src={selectedCountryData.flag}
          alt={`${selectedCountryData.name} flag`}
          className="country-flag"
        />
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/66cbf3fd98e173f04a35882552ceeb9212086979?placeholderIfAbsent=true"
          alt="Dropdown arrow"
          className={`dropdown-arrow ${isOpen ? "open" : ""}`}
        />
      </button>

      {isOpen && !disabled && (
        <div className="country-dropdown">
          <ul role="listbox" className="country-list">
            {countries.map(country => (
              <li key={country.code}>
                <button
                  type="button"
                  onClick={() => {
                    onCountryChange(country.code)
                    setIsOpen(false)
                  }}
                  className="country-option"
                  role="option"
                  aria-selected={selectedCountry === country.code}
                >
                  <img
                    src={country.flag}
                    alt={`${country.name} flag`}
                    className="country-flag"
                  />
                  <span>{country.name}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
